import React, { useEffect, useState } from "react";
import {
  Container,
  Grid,
  Card,
  Text,
  List,
  Avatar,
  Group,
  Badge,
  Box,
  Title,
  Select,
  Flex,
} from "@mantine/core";
import axios from "axios";
import { API, formatNumber } from "utiles/url";

export const TopProducts = ({ data, selectedBadge, setSelectedBadge }) => {
  const handleBadgeClick = async (badgeValue) => {
    setSelectedBadge(badgeValue);
  };

  return (
    <div
      style={{
        backgroundColor: "white",
        borderRadius: "8px",
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
        padding: "20px",
        marginBottom: "20px",
      }}
    >
      <Group position="apart">
        <Title order={4}>Top Products</Title>
        <Group spacing="xs">
          {[5, 10, 15].map((badge) => (
            <Badge
              key={badge}
              color={badge === selectedBadge ? "green" : "blue"}
              variant="light"
              onClick={() => handleBadgeClick(badge)}
              style={{ cursor: "pointer" }}
            >
              {badge}
            </Badge>
          ))}
        </Group>
      </Group>
      <Flex
        justify="space-between"
        align="center"
        mb="sm"
        style={{ borderBottom: "1px solid #e0e0e0", paddingBottom: "5px" }}
      >
        <Text size="sm" weight={600} color="#555">
          Name
        </Text>
        <Text size="sm" weight={600} color="#555">
          Total Orders
        </Text>
      </Flex>
      <List spacing="md" size="sm" style={{ marginTop: "15px" }}>
        {data?.top_products?.length > 0 ? (
          data?.top_products?.map((item, index) => (
            <List.Item
              key={index}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Group spacing="sm" style={{ flex: 1 }}>
                <Box style={{ display: "flex", flex: 1, minWidth: 0 }}>
                  <Text
                    size="sm"
                    weight={600}
                    style={{
                      width: "145px",
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      overflow: "visible",
                    }}
                  >
                    {item?.name}
                  </Text>
                  <Box
                    style={{
                      marginLeft: "20px",
                      flexShrink: 0,
                    }}
                  >
                    <Text size="sm" color="green" weight={700}>
                      {formatNumber(item.total_orders)}
                    </Text>
                  </Box>
                </Box>
              </Group>
            </List.Item>
          ))
        ) : (
          <Text>No data available</Text>
        )}
      </List>
    </div>
  );
};
